import React, { useState } from 'react'
import { Badge, Box, Divider, Group, Paper, Stack, Text } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { IconCalendar, IconChevronRight, IconCurrencyYuan, IconPhone, IconUser } from '@tabler/icons-react'
import { OrderInterface } from '../../typings/orderTypes'
import { formatDateToString } from '../../utils/dateTimeUtil'

interface OrderProps {
  order: OrderInterface
  statusMap: Map<string, string>
}

export default function Order({ order, statusMap }: OrderProps) {
  const navigate = useNavigate()
  const [isHovered, setIsHovered] = useState(false)

  const getStatusColor = (status: number) => {
    if (status === 40) return '#22c55e'
    return '#3b82f6'
  }

  const statusText = Object.entries(statusMap).find((entry) => entry[0] === order.status.toString())?.[1] || '未知'

  return (
    <Paper
      p="lg"
      onClick={() => navigate('/reports/' + order.id)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        borderRadius: '16px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 8px 16px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f3f4f6',
      }}
    >
      <Stack gap="md">
        <Group justify="space-between" align="flex-start">
          <Text size="lg" fw={600} style={{ color: '#1e3a8a', flex: 1 }}>
            {order.templateName}
          </Text>
          <Badge
            size="lg"
            radius="md"
            style={{
              backgroundColor: `${getStatusColor(order.status)}20`,
              color: getStatusColor(order.status),
              border: `1px solid ${getStatusColor(order.status)}40`,
            }}
          >
            {statusText}
          </Badge>
        </Group>

        <Divider />

        <Stack gap="sm">
          <Group gap="xs">
            <Box
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                backgroundColor: '#eff6ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconUser size={18} color="#3b82f6" />
            </Box>
            <Text size="sm" style={{ color: '#6b7280' }}>
              姓名：
            </Text>
            <Text size="sm" fw={500} style={{ color: '#374151' }}>
              {order.nameMask}
            </Text>
          </Group>

          <Group gap="xs">
            <Box
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                backgroundColor: '#eff6ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconPhone size={18} color="#3b82f6" />
            </Box>
            <Text size="sm" style={{ color: '#6b7280' }}>
              手机：
            </Text>
            <Text size="sm" fw={500} style={{ color: '#374151' }}>
              {order.phoneMask}
            </Text>
          </Group>

          <Group gap="xs">
            <Box
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                backgroundColor: '#eff6ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconCurrencyYuan size={18} color="#3b82f6" />
            </Box>
            <Text size="sm" style={{ color: '#6b7280' }}>
              金额：
            </Text>
            <Text size="sm" fw={600} style={{ color: '#f59e0b' }}>
              ¥{order.price.toFixed(2)}
            </Text>
          </Group>

          <Group gap="xs">
            <Box
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                backgroundColor: '#eff6ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconCalendar size={18} color="#3b82f6" />
            </Box>
            <Text size="sm" style={{ color: '#6b7280' }}>
              时间：
            </Text>
            <Text size="sm" style={{ color: '#6b7280' }}>
              {formatDateToString(order.createTime)}
            </Text>
          </Group>
        </Stack>

        <Divider />

        <Group justify="center" gap="xs">
          <Text size="sm" fw={600} style={{ color: '#3b82f6' }}>
            查看报告
          </Text>
          <IconChevronRight size={18} color="#3b82f6" />
        </Group>
      </Stack>
    </Paper>
  )
}
